import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivateLayoutModule } from './layout/private/private-layout.module';
import { PublicLayoutModule } from './layout/public/public-layout.module';

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    PublicLayoutModule,
    PrivateLayoutModule,
  ],
})
export class LibSharedFeatureModule { }
